import { Component, EventEmitter, Input, Output } from "@angular/core";

// Opened the same way as the "Export Standards" modal on View All Standards
// (view-all-standards-filter.component.html/.scss, .modal-overlay/.modal-content)
// - a plain *ngIf toggled directly in the host page's own template, not via
// NgbModal - so it shares that exact open/close behavior and backdrop instead
// of ng-bootstrap's own modal chrome.
@Component({
  selector: "app-share-link-modal",
  templateUrl: "./share-link-modal.component.html",
  styleUrls: ["./share-link-modal.component.scss"],
})
export class ShareLinkModalComponent {
  @Input() itemTitle: string = "";
  @Input() itemSubtitle: string = "";
  @Input() itemIcon: string = "/assets/images/building-standrad.svg";
  @Input() shareUrl: string = "";
  @Output() closeModal = new EventEmitter<void>();

  copied = false;
  private copiedTimeout: any;

  copyLink(): void {
    navigator.clipboard.writeText(this.shareUrl).then(() => {
      this.showCopiedState();
    });
  }

  shareViaEmail(): void {
    const subject = encodeURIComponent(this.itemTitle || "GRS Standard");
    const body = encodeURIComponent(
      `Here is a link to share: ${this.shareUrl}`
    );
    window.open(`mailto:?subject=${subject}&body=${body}`, "_self");
  }

  shareViaTeams(): void {
    const href = encodeURIComponent(this.shareUrl);
    const msgText = encodeURIComponent(this.itemTitle || "");
    window.open(
      `https://teams.microsoft.com/share?href=${href}&msgText=${msgText}`,
      "_blank"
    );
  }

  shareViaSharePoint(): void {
    // No universal "share to SharePoint" link scheme exists (SharePoint
    // sites are org-specific) - same action as Copy Link, per the user's
    // choice, so it can be pasted into a SharePoint page/doc manually.
    this.copyLink();
  }

  close(): void {
    this.closeModal.emit();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  private showCopiedState(): void {
    this.copied = true;
    clearTimeout(this.copiedTimeout);
    this.copiedTimeout = setTimeout(() => {
      this.copied = false;
    }, 2500);
  }
}
